import { render, staticRenderFns } from "./SubBrandSelectorDialog.vue?vue&type=template&id=5f01e63d"
import script from "./SubBrandSelectorDialog.vue?vue&type=script&lang=js"
export * from "./SubBrandSelectorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports